<template>
  <div class="min-h-screen bg-white flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div class="bg-white rounded-lg shadow-lg p-8 border border-[#E6D6CD]">
        <div class="text-center">
          <div class="mb-6">
            <svg class="mx-auto h-16 w-16 text-[#795833]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414" />
            </svg>
          </div>

          <h2 class="mt-6 text-3xl font-header font-bold text-[#2D4D31]">
            {{ errorType === 'bug' ? 'Technical Issue Detected' : 'Service Temporarily Unavailable' }}
          </h2>
          <p class="mt-4 text-base text-[#5B4F47] font-body leading-relaxed">
            <template v-if="errorType === 'bug'">
              Sorry for the technical difficulties. We have detected an internal server error. Please report this issue
              using our contact form so we can fix it promptly.
            </template>
            <template v-else>
              We're experiencing technical difficulties. Our servers are currently down for maintenance or experiencing
              issues. Please try again in a few moments.
            </template>
          </p>

          <div class="mt-8 space-y-4">
            <button @click="retryConnection" :disabled="isRetrying"
              class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-body font-medium rounded-md text-white bg-[#2D4D31] hover:bg-[#253439] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2D4D31] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              <svg v-if="isRetrying" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
              </svg>
              {{ isRetrying ? 'Checking connection...' : 'Retry Connection' }}
            </button>

            <a v-if="errorType === 'bug'" href="/contact"
              class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-body font-medium rounded-md text-white bg-[#8C3839] hover:bg-[#7A2F30] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8C3839] transition-colors">
              Report Issue
            </a>
            <button v-else @click="refreshPage"
              class="w-full inline-flex items-center justify-center px-6 py-3 border border-[#B29E84] text-base font-body font-medium rounded-md text-[#5B4F47] bg-white hover:bg-[#FFF5EA] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2D4D31] transition-colors">
              Refresh Page
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useApiStatus } from '../composables/useApiStatus.js'

const { checkApiHealth, errorType } = useApiStatus()
const isRetrying = ref(false)

const retryConnection = async () => {
  isRetrying.value = true
  try {
    const isHealthy = await checkApiHealth()
    if (isHealthy) {
      window.location.reload()
    } else {
      setTimeout(() => {
        isRetrying.value = false
      }, 2000)
    }
  } catch (error) {
    setTimeout(() => {
      isRetrying.value = false
    }, 2000)
  }
}

const refreshPage = () => {
  window.location.reload()
}
</script>